import { create } from "zustand"

export type TransitionScope = "map" | "full"

type Phase = "idle" | "fadeIn" | "hold" | "fadeOut"

interface TransitionState {
    isActive: boolean
    scope: TransitionScope
    phase: Phase
    onSwitch: (() => void) | null

    fadeTransition: (onSwitch: () => void, scope?: TransitionScope) => void
    setPhase: (phase: Phase) => void
    finish: () => void
}

export const useTransitionStore = create<TransitionState>((set) => ({
    isActive: false,
    scope: "full",
    phase: "idle",
    onSwitch: null,

    fadeTransition: (onSwitch, scope = "full") => {
        set({
            isActive: true,
            scope,
            phase: "fadeIn",
            onSwitch,
        })
    },

    setPhase: (phase) => {
        set({ phase })
    },

    finish: () => {
        set({
            isActive: false,
            phase: "idle",
            onSwitch: null,
        })
    },
}))
